export const RECEIVE_WEBINAR_DATA = "RECEIVE_WEBINAR_DATA";
export const SHOW_LOADER = "SHOW_WEBINARS_LOADER";

export interface IWebinarsState {
    webinarsData?: WebinarData[];
    isLoading: boolean;
}

export interface WebinarData {
    title?: string;
    summary?: string;
    author?: string;
    feedUrl?: string;
    imageUrl?: string;
    publishDate?: string;
}

export interface GetWebinarDataAction {
    type: "RECEIVE_WEBINAR_DATA";
    webinarsData: WebinarData[];
}
export interface ShowAction {
    type: "SHOW_WEBINARS_LOADER";
    isLoading: boolean;
}

export type KnownAction = GetWebinarDataAction | ShowAction;
